function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33393 4.08645C7.94469 3.94478 7.51431 4.14547 7.37264 4.5347C7.23097 4.92394 7.43166 5.35432 7.8209 5.49599L9.28011 6.0271C9.66934 6.16877 10.0997 5.96808 10.2414 5.57884C10.3831 5.18961 10.1824 4.75923 9.79314 4.61756L8.33393 4.08645Z",
  fill: "#222222"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.34813 16.0098C6.17785 15.6322 5.73371 15.4641 5.35612 15.6344C4.97852 15.8047 4.81045 16.2488 4.98073 16.6264L5.99629 18.8785C6.11753 19.1473 6.38507 19.3202 6.67999 19.3202H14.6376C15.0518 19.3202 15.3876 18.9844 15.3876 18.5702C15.3876 18.156 15.0518 17.8202 14.6376 17.8202H7.16451L6.34813 16.0098Z",
  fill: "#222222"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.58398 18.7395C5.58398 19.4644 4.99636 20.052 4.27148 20.052C3.54661 20.052 2.95898 19.4644 2.95898 18.7395C2.95898 18.0146 3.54661 17.427 4.27148 17.427C4.99636 17.427 5.58398 18.0146 5.58398 18.7395Z",
  fill: "#222222"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0215 20.052C17.7464 20.052 18.334 19.4644 18.334 18.7395C18.334 18.0146 17.7464 17.427 17.0215 17.427C16.2966 17.427 15.709 18.0146 15.709 18.7395C15.709 19.4644 16.2966 20.052 17.0215 20.052Z",
  fill: "#222222"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.40545 17.0231C5.01622 16.8814 4.81553 16.4511 4.9572 16.0618L8.402 6.59731C8.54367 6.20808 8.97406 6.00739 9.36329 6.14906C9.75252 6.29073 9.95321 6.72111 9.81155 7.11034L6.36674 16.5749C6.22507 16.9641 5.79469 17.1648 5.40545 17.0231Z",
  fill: "#EB4C60"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1465 10.1143C15.1465 9.70004 15.4823 9.36426 15.8965 9.36426H20.209C20.6232 9.36426 20.959 9.70004 20.959 10.1143C20.959 10.5285 20.6232 10.8643 20.209 10.8643H15.8965C15.4823 10.8643 15.1465 10.5285 15.1465 10.1143Z",
  fill: "#B9FF60"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.709 12.3643C12.709 11.95 13.0448 11.6143 13.459 11.6143H17.7715C18.1857 11.6143 18.5215 11.95 18.5215 12.3643C18.5215 12.7785 18.1857 13.1143 17.7715 13.1143H13.459C13.0448 13.1143 12.709 12.7785 12.709 12.3643Z",
  fill: "#FFDC60"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.3965 14.6143C14.3965 14.2 14.7323 13.8643 15.1465 13.8643H19.459C19.8732 13.8643 20.209 14.2 20.209 14.6143C20.209 15.0285 19.8732 15.3643 19.459 15.3643H15.1465C14.7323 15.3643 14.3965 15.0285 14.3965 14.6143Z",
  fill: "#FF6D60"
});

function SvgKickboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickboard);
export default __webpack_public_path__ + "static/media/kickboard.f7b410b2.svg";
export { ForwardRef as ReactComponent };